<template>
  <section class="hp-faq-section">
    <div class="hp-faq-container">

      <!-- Header -->
      <div class="hp-faq-header">
        <span class="hp-faq-badge">সচরাচর জিজ্ঞাসা</span>
        <h2 class="wow fadeInUp" data-wow-delay=".2s">সচরাচর জিজ্ঞাসাসমূহ</h2>
        <p class="wow fadeInUp" data-wow-delay=".3s">বিসিএস প্রস্তুতি সম্পর্কিত সাধারণ প্রশ্নের উত্তর</p>
      </div>

      <!-- Accordion List -->
      <div class="hp-faq-list">
        <div
          v-for="(item, i) in faqs"
          :key="i"
          class="hp-faq-item"
          :class="{ open: openIndex === i }"
        >
          <button class="hp-faq-question" @click="toggle(i)">
            <span>{{ item.q }}</span>
            <span class="hp-faq-chevron">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
          <div class="hp-faq-answer-wrap">
            <div class="hp-faq-answer-inner">{{ item.a }}</div>
          </div>
        </div>
      </div>

      <!-- More FAQ Link -->
      <div class="hp-faq-more">
        <a href="/faq" class="hp-faq-more-btn">
          আরও প্রশ্নের উত্তর দেখুন
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

    </div>
  </section>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "WelcomePageFaq",
  setup() {
    const openIndex = ref(null);

    const toggle = (i) => {
      openIndex.value = openIndex.value === i ? null : i;
    };

    const faqs = [
      {
        q: "বিসিএস প্রস্তুতি অ্যাপটি কি? কাদের জন্য এই অ্যাপ?",
        a: "বিসিএস সহ যে কোন ধরণের সরকারী চাকুরীর প্রস্তুতির জন্যই এই অ্যাপ। আপনার মোবাইলে যে কোন জায়গা থেকে লক্ষাধিক পরীক্ষার্থীদের সাথে বিভিন্ন রকম লাইভ পরীক্ষা, টপিক কিংবা বিষয়ভিত্তিক পরীক্ষা দিয়ে নিজেকে প্রতিনিয়ত যাচাই করার জন্যই এই প্ল্যাটফর্ম: বিসিএস প্রস্তুতি।",
      },
      {
        q: "আমি এখনও ছাত্র, আমি কিভাবে বিসিএস প্রস্তুতি শুরু করব?",
        a: "বিসিএস এখন অনেক বেশী প্রতিযোগিতাপূর্ণ। তাই আগে থেকেই প্রস্তুত হওয়া বিচক্ষণ সিদ্ধান্ত। এখন থেকে ম্যাথ আর ইংলিশ এর ওপর জোর দিন। রেগুলার বাংলা ও ইংরেজি পত্রিকা পড়ুন। মুক্তিযুদ্ধ নিয়ে উপন্যাস পড়ুন। ইউটিউবে ইংলিশ TED Talk শুনুন। নিয়মিত গণিত চর্চা রাখুন।",
      },
      {
        q: "বিসিএস প্রস্তুতি অ্যাপ কিভাবে ইউজ করলে সবচেয়ে ভাল করতে পারব?",
        a: "আপনি যেই টপিক পড়ছেন, সেটা পড়ার পর অ্যাপে ঢুকে টপিক-ভিত্তিক পরীক্ষা যত বেশি দিবেন তত উপকার পাবেন। পরীক্ষায় যা ভুল করছেন, সেগুলো মার্ক করে রাখুন এবং রিভিশন দিন। আর্কাইভ থেকে পুরাতন পরীক্ষাগুলো দিয়ে নিজেকে যাচাই করুন।",
      },
      {
        q: "চাকরির পাশাপাশি কিভাবে পড়াশোনা করব?",
        a: "ঠিক আপনাদের কথা চিন্তা করেই আমরা নিয়ে এসেছি 'বিসিএস প্রস্তুতি (৬ মাস)' কোর্সটি। দৈনিক ২–৩ ঘণ্টাতেই শেষ করা যায় — এমনভাবেই তৈরি করা হয়েছে সম্পূর্ণ সিলেবাস এবং রুটিন। এই কোর্সটি ফলো করলেই চাকুরীর পাশাপাশি একটা ভালো প্রস্তুতি নিতে পারবেন।",
      },
      {
        q: "অনেকদিন ধরে চেষ্টা করছি, ভালো ফলাফল করতে পারছি না। কি করব?",
        a: "প্রচুর পরিমাণে পড়াশোনা করার কোন বিকল্প নেই। সাথে বিকল্প নেই পরীক্ষা দেয়ার। যত বেশি পড়বেন তত ভালো করবেন। যত পরীক্ষা দেবেন তত উত্তীর্ণ হবার সম্ভাবনা বাড়বে। কোথায় বেশি ভুল করেন সেগুলোর দিকে নজর দিন এবং কাজ করুন।",
      },
    ];

    return { faqs, openIndex, toggle };
  },
  metaInfo: {
    title: "সচরাচর জিজ্ঞাসাসমূহ",
    meta: [
      { name: "description", content: "বিসিএস প্রস্তুতি অ্যাপ সম্পর্কে সচরাচর জিজ্ঞাসাসমূহ" },
      { property: "og:title", content: "বিসিএস প্রস্তুতি অ্যাপ সম্পর্কে সচরাচর জিজ্ঞাসাসমূহ" },
      { property: "og:url", content: "www.bcsprostuti.com/faq" },
    ],
  },
});
</script>

<style scoped>
* { box-sizing: border-box; }

/* ── Section ── */
.hp-faq-section {
  background: #f1f5f9;
  padding: 72px 0 80px;
}

.hp-faq-container {
  max-width: 780px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ── Header ── */
.hp-faq-header {
  text-align: center;
  margin-bottom: 40px;
}
.hp-faq-badge {
  display: inline-block;
  font-size: 0.7rem; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #F59E0B;
  background: rgba(245,158,11,0.1);
  border: 1px solid rgba(245,158,11,0.3);
  padding: 4px 14px; border-radius: 50px;
  margin-bottom: 14px;
}
.hp-faq-header h2 {
  font-size: clamp(1.4rem, 3vw, 2rem);
  font-weight: 800;
  color: #191b47;
  margin-bottom: 10px;
  line-height: 1.3;
  text-align: center;
}
.hp-faq-header p {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  text-align: center;
}

/* ── Accordion List ── */
.hp-faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

/* ── Item ── */
.hp-faq-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.hp-faq-item:hover {
  box-shadow: 0 4px 20px rgba(25,27,71,0.07);
}
.hp-faq-item.open {
  border-color: #191b47;
  box-shadow: 0 6px 24px rgba(25,27,71,0.1);
}

/* ── Question ── */
.hp-faq-question {
  width: 100%;
  min-width: 0;
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; padding: 20px 22px;
  background: none; border: none; cursor: pointer;
  font-size: 0.95rem; font-weight: 600; color: #1e293b;
  text-align: left; line-height: 1.55;
  font-family: 'Noto Sans Bengali', 'Noto Sans', system-ui, sans-serif;
  transition: color 0.18s;
}
.hp-faq-question span:first-child {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
  text-align: left;
}
.hp-faq-item.open .hp-faq-question { color: #191b47; }

/* ── Chevron ── */
.hp-faq-chevron {
  flex-shrink: 0;
  width: 28px; height: 28px;
  background: #f1f5f9; border-radius: 50%;
  color: #94a3b8;
  display: flex; align-items: center; justify-content: center;
  transition: transform 0.28s cubic-bezier(0.34,1.56,0.64,1), background 0.2s, color 0.2s;
}
.hp-faq-item.open .hp-faq-chevron {
  transform: rotate(180deg);
  background: #191b47;
  color: #fff;
}

/* ── Grid-based accordion — zero width impact ── */
.hp-faq-answer-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.32s ease;
}
.hp-faq-item.open .hp-faq-answer-wrap {
  grid-template-rows: 1fr;
}
.hp-faq-answer-inner {
  overflow: hidden;
  min-height: 0;
  padding: 0 22px;
  font-size: 0.88rem; color: #475569; line-height: 1.8;
  overflow-wrap: break-word;
  word-break: break-word;
  text-align: left;
  font-family: 'Noto Sans Bengali', 'Noto Sans', system-ui, sans-serif;
  transition: padding 0.32s ease;
}
.hp-faq-item.open .hp-faq-answer-inner {
  padding: 16px 22px 22px;
}

/* ── More Button ── */
.hp-faq-more {
  margin-top: 32px;
  text-align: left;
}
.hp-faq-more-btn {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 0.9rem; font-weight: 700;
  color: #191b47;
  background: #fff;
  border: 1.5px solid #191b47;
  padding: 12px 24px; border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s;
}
.hp-faq-more-btn:hover {
  background: #191b47;
  color: #fff;
}

@media (max-width: 600px) {
  .hp-faq-section { padding: 52px 0 60px; }
  .hp-faq-question { font-size: 0.88rem; padding: 16px 18px; }
  .hp-faq-answer-inner { padding: 0 18px; }
  .hp-faq-item.open .hp-faq-answer-inner { padding: 14px 18px 18px; }
}
</style>